import type { ReactNode } from "react"
import { createContext, useContext } from "react"
import { DateTimeUtils } from "./date-utils/date-time-utils"
import type { TUtcDateTime } from "./types"

const fallbackValue = new DateTimeUtils(null)
const DateTimeUtilsContext = createContext<DateTimeUtils>(fallbackValue)

type TDateTimeUtilsProviderProps = {
  appTime: TUtcDateTime
  children: ReactNode
}

export function DateTimeUtilsProvider({ appTime, children }: TDateTimeUtilsProviderProps) {
  const func = "DateTimeUtilsProvider"
  console.log(`%c${func}`, "color:CornflowerBlue", { appTime })

  const dtu = new DateTimeUtils(appTime)

  return <DateTimeUtilsContext value={dtu}>{children}</DateTimeUtilsContext>
}

export const useDateTimeUtils = () => {
  const context = useContext(DateTimeUtilsContext)
  return context
}
